import { InfoBanner } from "../../components/InfoBanner";
import { ExternalLinkWrapper } from "../../components/ExternalLinkWrapper";

type Props = {
  href: string;
};

export const AdminUsersMovingNotice = ({ href }: Props) => {
  return (
    <InfoBanner>
      Admin users are moving to the new admin, and this page will be removed
      soon.{" "}
      {/* Our own admin: keep the referrer, so the new admin can tell visits
          that came from here. */}
      <ExternalLinkWrapper href={href} rel="noopener">
        Manage admin users in the new admin →
      </ExternalLinkWrapper>
      {"\n"}
      You need the "Manage admins in organization" role there. Ask Heaps if you
      can't open the page.
    </InfoBanner>
  );
};
